import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';

import 'swiper/css/bundle';

const swiper = new Swiper('.HeroSlider', {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
    slidesPerView: 1,
    loop: true,
    speed: 1000,
    autoplay: {
        delay: 5500,
    },
    pagination: {
        el: '.HeroSlider__pagination',
        type: 'custom',
        renderCustom: (swiper, current, total) => {
            return `<div><span class="swiper-pagination-current">${current}</span>/<span>${total}</span></div>`;
        },
    },
    navigation: {
        nextEl: '.swiper-next-btn',
        prevEl: '.swiper-prev-btn',
    },
});
